import PropTypes from 'prop-types';

import { FederatedModule } from '@zenbusiness/application-commons-federation';
import { LoadingZone } from '@zenbusiness/application-commons-loading';
import ErrorState from '@zenbusiness/zui/ErrorState';
import LoadingSpinner from '@zenbusiness/zui/LoadingSpinner';

import { FEDERATED } from '#client/build-env';

const fedProps = {
  loadingElement: <LoadingSpinner />,
  errorElement: <ErrorState />,
};

function BankingWidgetV2({ widgetId }) {
  return (
    <>
      <LoadingZone.Prepare loadId={widgetId} />
      <FederatedModule
        exportName="FederatedBankingWidgetV2"
        silent
        {...fedProps}
        {...FEDERATED.bankingUI}
        widgetId={widgetId}
      />
    </>
  );
}

BankingWidgetV2.propTypes = {
  /** Unique ID to use for the widget */
  widgetId: PropTypes.string,
};

export default BankingWidgetV2;
